export default "__VITE_ASSET__C41fpt1y__"